import {axios, HOST, config} from './settiing';

export default {
  getChargeLogOfStatistic(start, end, diffDate) {
    return axios.get(`${HOST}/resource/chargeLog/groupByStation/${start}/${end}/${diffDate}`, config);
  },
  getChargeLogBetween(start, end) {
    return axios.get(`${HOST}/resource/chargeLog/${start}/${end}`, config);
  },
  getChargeLogForVehicle(vehicleId, start, end) {
    return axios.get(`${HOST}/resource/chargeLog/vehicle/${vehicleId}/${start}/${end}`, config);
  },
  getChargeLogForDriver(driverId) {
    return axios.get(`${HOST}/resource/chargeLog/driver/${driverId}`, config);
  },
  getChargeLogDetail(id) {
    return axios.get(`${HOST}/resource/chargeLog/detail/${id}`, config);
  }

}